export const PRODUCT_LEVEL_OPTIONS = [
    { display: 'Department', value: 'Department' },
    { display: 'Super Category', value: 'Super Category' },
    { display: 'Category', value: 'Category' },
    { display: 'Sub-Category', value: 'Sub-Category' },
    { display: 'UPC', value: 'UPC' },
    { display: 'Parent Company', value: 'Parent Company' },
    { display: 'Manufacturer', value: 'Manufacturer' },
    { display: 'Brand', value: 'Brand' },
];
